// Dependencies
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";



// Components
import ViewList from "../../components/viewList";
import Accordion from '../../components/accordion'



function DocumentsShowScreen(props){
  const location = useLocation();


   const  _setBradcrumbTitle = (title) =>{
    
    props.getBreadcrumbs({
          assetUrl: '/documents-show',
          url: '/documents-show',
          assetTitle: title
        });
  }

    return (
      <>
      <ViewList 
        files={true}
        colorGrey={true}
        setBradcrumbTitle = {(title) => _setBradcrumbTitle(title)}
        assignData={{
          id: location.state?.id,
          url: location.state?.url,
          location: location,
          modal: false
        }}  
          {...props}
          />
     </> 
    );
  }

  export default DocumentsShowScreen




